import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'PageHelp.Description',
    defaultMessage: 'Help & FAQ',
  },
});

export default messages;
